import SquaredBoxSvg278x338 from './SquaredBoxSvg278x338';

export default SquaredBoxSvg278x338;
export { SquaredBoxSvg278x338 };
